import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  projectId: string;
};

export const adminGetProjectDetail = createQueryFn(
  QueryNameSpace.getProjectDetail,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, { projectId }] = queryKey;
    return await DigiobcanApi.adminGetProjectDetail(projectId);
  },
);
